"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/floating-label/dist/mdc.floating-label.css");
